import { ApplicationSourceEnum } from './applicationSource.enum';
import { v4 as uuidv4 } from 'uuid';
import { CartProductDto } from './cartProduct.dto';
import { CustomerDto } from './customer.dto';
import { CustomerAddressDto } from './customerAddress.dto';
import { DiscountTypeDto } from './discountType.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';
import { OrderTypeDto } from './orderType.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
import { SaleUnitCartSplitDto } from './saleUnitCartSplit.dto';
import { ServiceChargeDto } from './serviceCharge.dto';
import { TableGuestDto } from './tableGuest.dto';
import { OrderNoteOptionDto } from './orderNoteOption.dto';
import { MerchantPaymentMethodOptionDto } from './merchantPaymentMethodOption.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';
import { KerbCollectionDto } from './kerbCollection.dto';
import { GiftCardDto } from './gift-card/giftCard.dto';
import { OrderFlightInfoForCreateDto } from './airport-integration/order-flight-info-for-create.dto';
import { CustomerLoyaltyPaymentDto } from './customer-loyalty-payment.dto';
import { DeliverAreaDto } from './deliverArea.dto';
import { CartOrderDto } from './cartOrder.dto';

export interface CartRequestDtoParams {
  merchantId: number,
  cartItems: CartProductDto[],
  customerId?: number,
  merchant?: MerchantDto,
  customer?: CustomerDto,
  orderType?: OrderTypeDto,
  deliveryAddress?: CustomerAddressDto,
  merchantSaleUnit?: MerchantSaleUnitDto,
  orderNote?: string,
  merchantPaymentMethod?: MerchantPaymentMethodDto,
  giftCard?: GiftCardDto,
  orderRequestedDateTime?: Date,
  discountType?: DiscountTypeDto,
  serviceCharge?: ServiceChargeDto,
  applicationSourceId?: number,
  status?: number,
  saleUnitCart?: SaleUnitCartDto,
  tableGuest?: TableGuestDto,
  isUniversalPOSCartEnabled?: boolean,
  isUniversalKioskCartEnabled?: boolean,
  totalBasket?: number,
  clientSideId?: string,
  orderNoteOptions?: OrderNoteOptionDto[],
  saleUnitCartSplit?: SaleUnitCartSplitDto,
  merchantPaymentMethodOption?: MerchantPaymentMethodOptionDto,
  orderPayments?: MerchantPaymentMethodDto[],
  isEatInSelected?: boolean,
  isTakeOutSelected?: boolean,
  flagNumber?: number,
  managerEmployeeId?: number,
  operatorEmployeeId?: number,
  selectedApiGiftCardUrlEnvironment?: string,
  selectedApiBankingDepositUrlEnvironment?: string,
  localStorageApiKey?: string,
  kerbSideData?: KerbCollectionDto,
  flightInfo?: OrderFlightInfoForCreateDto,
  customerLoyaltyBurnedInfo?: any,
  originalOrderId?: number,
  staffAccessId?: number,
  staffPriceChangeAccess?: boolean,
  cartId?: number;
  partialPaymentAmount?: number | null;
}
export class CartRequestDto {
  public applicationSourceEnum = ApplicationSourceEnum;
  public merchantId: number;
  public basketId: string;
  public cartItems: CartProductDto[];
  public customerId?: number;
  public posDeviceId?: number;
  public merchant?: MerchantDto;
  public customer?: CustomerDto;
  public orderType?: OrderTypeDto;
  public deliveryAddress?: CustomerAddressDto;
  public merchantSaleUnit?: MerchantSaleUnitDto;
  public orderNote?: string;
  public merchantPaymentMethod?: MerchantPaymentMethodDto;
  public giftCard?: GiftCardDto;
  public orderRequestedDateTime?: Date;
  public discountType?: DiscountTypeDto;
  public serviceCharge?: ServiceChargeDto;
  public applicationSourceId?: number;
  public status?: number;
  public id?: number;
  public saleUnitCart?: SaleUnitCartDto;
  public tableGuest?: TableGuestDto;
  public isPosTableOrder: boolean;
  public isPosTableGuestOrder: boolean;
  public isGiftCardPayment: boolean;
  public isPosMultiMerchantCart: boolean;
  public isUniversalPOSCartEnabled: boolean;
  public isKioskMultiMerchantCart: boolean;
  public isUniversalKioskCartEnabled: boolean;
  public totalBasket?: number;
  public clientSideId?: string;
  public orderNoteOptions?: OrderNoteOptionDto[];
  public saleUnitCartSplit?: SaleUnitCartSplitDto;
  public isPosSplitTableOrder: boolean;
  public merchantPaymentMethodOption?: MerchantPaymentMethodOptionDto;
  public isPosSplitTableMainTableOrder: boolean;
  public orderPayments?: MerchantPaymentMethodDto[];
  public isSplitOrderPayment: boolean;
  public isPosGiftCardPayment: boolean;
  public isPosCardPayment: boolean;
  public isEatInSelected?: boolean;
  public isTakeOutSelected?: boolean;
  public flagNumber?: number;
  public managerEmployeeId?: number;
  public operatorEmployeeId?: number;
  public selectedApiGiftCardUrlEnvironment?: string;
  public selectedApiBankingDepositUrlEnvironment?: string;
  public localStorageApiKey?: string;
  public kerbSideData?: KerbCollectionDto;
  public flightInfo?: OrderFlightInfoForCreateDto;
  public customerLoyaltyBurnedInfo?: {
    customerLoyaltyInfo: CustomerLoyaltyPaymentDto,
    customerLoyaltyPointsApplied: number
  };
  public originalOrderId?: number;
  public staffAccessId?: number;
  public staffPriceChangeAccess?: boolean;
  public merchantQuantities?: number;
  public multiOrderCode?: string;
  public noReceipt?: boolean;
  public deliveryArea?: DeliverAreaDto;
  public cartId?: number;
  public partialPaymentAmount?: number | null;
  public cartOrders?: CartOrderDto[];
  public isPartialPayment?: boolean;
  public ageConfirmationCompleted?: boolean;

  /**
   * CartRequestDto
   * @param merchantId
   * @param cartItems
   * @param customerId
   * @param merchant
   * @param customer
   * @param orderType
   * @param deliveryAddress
   * @param merchantSaleUnit
   * @param orderNote
   * @param merchantPaymentMethod
   * @param giftCard
   * @param orderRequestedDateTime
   * @param discountType
   * @param serviceCharge
   * @param applicationSourceId
   * @param status
   * @param saleUnitCart
   * @param tableGuest
   * @param isUniversalPOSCartEnabled
   * @param isUniversalKioskCartEnabled
   * @param totalBasket
   * @param clientSideId
   * @param orderNoteOptions
   * @param saleUnitCartSplit
   * @param merchantPaymentMethodOption
   * @param orderPayments
   * @param isEatInSelected
   * @param isTakeOutSelected
   * @param flagNumber
   * @param managerEmployeeId
   * @param operatorEmployeeId
   * @param selectedApiGiftCardUrlEnvironment
   * @param selectedApiBankingDepositUrlEnvironment
   * @param localStorageApiKey
   * @param kerbSideData
   * @param flightInfo
   * @param customerLoyaltyBurnedInfo
   * @param originalOrderId Optional original order ID used when reopening order.
   * @param staffAccessId
   * @param staffPriceChangeAccess
   * @param noReceipt
   * @param cartOrders
   * @param isPartialPayment
   * @param ageConfirmationCompleted
   */
  constructor(
    merchantId: number,
    cartItems: CartProductDto[],
    customerId?: number,
    merchant?: MerchantDto,
    customer?: CustomerDto,
    orderType?: OrderTypeDto,
    deliveryAddress?: CustomerAddressDto,
    merchantSaleUnit?: MerchantSaleUnitDto,
    orderNote?: string,
    merchantPaymentMethod?: MerchantPaymentMethodDto,
    giftCard?: GiftCardDto,
    orderRequestedDateTime?: Date,
    discountType?: DiscountTypeDto,
    serviceCharge?: ServiceChargeDto,
    applicationSourceId?: number,
    status?: number,
    saleUnitCart?: SaleUnitCartDto,
    tableGuest?: TableGuestDto,
    isUniversalPOSCartEnabled?: boolean,
    isUniversalKioskCartEnabled?: boolean,
    totalBasket?: number,
    clientSideId?: string,
    orderNoteOptions?: OrderNoteOptionDto[],
    saleUnitCartSplit?: SaleUnitCartSplitDto,
    merchantPaymentMethodOption?: MerchantPaymentMethodOptionDto,
    orderPayments?: MerchantPaymentMethodDto[],
    isEatInSelected?: boolean,
    isTakeOutSelected?: boolean,
    flagNumber?: number,
    managerEmployeeId?: number,
    operatorEmployeeId?: number,
    selectedApiGiftCardUrlEnvironment?: string,
    selectedApiBankingDepositUrlEnvironment?: string,
    localStorageApiKey?: string,
    kerbSideData?: KerbCollectionDto,
    flightInfo?: OrderFlightInfoForCreateDto,
    customerLoyaltyBurnedInfo?: any,
    originalOrderId?: number,
    staffAccessId?: number,
    staffPriceChangeAccess?: boolean,
    noReceipt?: boolean,
    deliveryArea?: DeliverAreaDto,
    cartOrders?: CartOrderDto[],
    isPartialPayment?: boolean,
    ageConfirmationCompleted?: boolean
  ) {
    this.merchantId = merchantId;
    this.customerId = customerId;
    this.cartItems = cartItems;
    this.merchant = merchant;
    this.customer = customer;
    this.orderType = orderType;
    this.deliveryAddress = deliveryAddress;
    this.merchantSaleUnit = merchantSaleUnit;
    this.orderNote = orderNote;
    this.merchantPaymentMethod = merchantPaymentMethod;
    this.giftCard = giftCard;
    this.orderRequestedDateTime = orderRequestedDateTime;
    this.discountType = discountType;
    this.serviceCharge = serviceCharge;
    this.applicationSourceId = applicationSourceId;
    this.status = status;
    this.saleUnitCart = saleUnitCart;
    this.tableGuest = tableGuest;
    this.isUniversalPOSCartEnabled = isUniversalPOSCartEnabled || false;
    this.isUniversalKioskCartEnabled = isUniversalKioskCartEnabled || false; //UP-4852 - Universal Basket on Kiosk App
    this.totalBasket = totalBasket; //UP-4852 - Universal Basket on Kiosk App
    this.clientSideId = clientSideId; //UP-4881 - Create a table for track the order and order_payments on Kiosk App
    this.orderNoteOptions = orderNoteOptions;
    this.saleUnitCartSplit = saleUnitCartSplit;
    this.merchantPaymentMethodOption = merchantPaymentMethodOption;
    this.orderPayments = orderPayments;
    this.isEatInSelected = isEatInSelected; //UP-4950 - Kiosk/POS - New properties on CartRequestDTO to create order
    this.isTakeOutSelected = isTakeOutSelected; //UP-4950 - Kiosk/POS - New properties on CartRequestDTO to create order
    this.flagNumber = flagNumber; //UP-4950 - Kiosk/POS - New properties on CartRequestDTO to create order
    this.managerEmployeeId = managerEmployeeId; //UP-4780 - Save validated ManagerEmployeeId
    this.operatorEmployeeId = operatorEmployeeId ? operatorEmployeeId : null;
    this.selectedApiGiftCardUrlEnvironment = selectedApiGiftCardUrlEnvironment; //UP-5575 - POS - Change GiftCard Redeem to use Third Party service
    this.selectedApiBankingDepositUrlEnvironment = selectedApiBankingDepositUrlEnvironment;
    this.localStorageApiKey = localStorageApiKey;
    this.kerbSideData = kerbSideData;
    this.flightInfo = flightInfo;
    this.customerLoyaltyBurnedInfo = customerLoyaltyBurnedInfo;
    this.originalOrderId = originalOrderId ? originalOrderId : null;
    this.staffAccessId = staffAccessId ? staffAccessId : null;
    this.staffPriceChangeAccess = staffPriceChangeAccess ? staffPriceChangeAccess : false;
    this.noReceipt = noReceipt ? noReceipt : null;
    this.deliveryArea = deliveryArea ? deliveryArea : null; 
    this.isPartialPayment = !!isPartialPayment;
    this.ageConfirmationCompleted = ageConfirmationCompleted ? ageConfirmationCompleted : false; 

    this.isPosTableOrder = this.setIsPosTableOrder(
      applicationSourceId,
      saleUnitCart
    );

    // Saves podDeviceId when is available - order coming from WEB-POS
    this.posDeviceId = this.getPosDeviceId();

    this.isPosTableGuestOrder = this.setIsPosTableGuestOrder(
      applicationSourceId,
      saleUnitCart,
      tableGuest
    );

    this.isPosMultiMerchantCart = this.setIsPosMultiMerchantCart(
      applicationSourceId,
      cartItems
    );

    this.isKioskMultiMerchantCart = this.setIsKioskMultiMerchantCart(
      applicationSourceId,
      cartItems
    );

    this.isGiftCardPayment = this.setIsGiftCardPayment(merchantPaymentMethod);

    this.isPosSplitTableOrder = this.setIsPosSplitTableOrder(
      applicationSourceId,
      saleUnitCartSplit
    );

    this.isPosSplitTableMainTableOrder = this.setIsPosSplitTableMainTableOrder(
      applicationSourceId,
      saleUnitCart
    );
    this.cartOrders = cartOrders;

    this.isSplitOrderPayment = this.setIsSplitOrderPayment(orderPayments);

    this.isPosGiftCardPayment = this.setIsPosGiftCardPayment(
      applicationSourceId,
      orderPayments
    );

    this.isPosCardPayment = this.setIsPosCardPayment(
      applicationSourceId,
      orderPayments
    );

    if (saleUnitCartSplit && saleUnitCartSplit.basketId) {
      this.basketId = saleUnitCartSplit.basketId;
    } else if (saleUnitCart && saleUnitCart.basketId) {
      this.basketId = saleUnitCart.basketId;
    } else {
      this.basketId = uuidv4();
    }
  }

  /**
   * Gets POS Device Id from localStorage.
   * @returns POS Device Id or null if not available.
   */
  private getPosDeviceId(): number | null {
    try {
      const posDeviceId = localStorage.getItem('_posDeviceId');
      return Number(posDeviceId);
    } catch (error) {
      return null;
    }
  }

  private setIsPosTableOrder(
    applicationSourceId: number,
    saleUnitCart: SaleUnitCartDto
  ) {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      !!saleUnitCart
    );
  }

  private setIsPosTableGuestOrder(
    applicationSourceId: number,
    saleUnitCart: SaleUnitCartDto,
    tableGuest: TableGuestDto
  ) {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      !!saleUnitCart &&
      !!tableGuest
    );
  }

  private setIsPosMultiMerchantCart(
    applicationSourceId: number,
    cartItems: CartProductDto[]
  ) {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      [...new Set(cartItems.map((x) => x.merchantId || x.merchant?.id))]
        ?.length > 1
    );
  }

  private setIsKioskMultiMerchantCart(
    applicationSourceId: number,
    cartItems: CartProductDto[]
  ) {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_KIOSK &&
      [...new Set(cartItems.map((x) => x.merchantId || x.merchant?.id))]
        ?.length > 1
    );
  }

  private setIsGiftCardPayment(
    merchantPaymentMethod: MerchantPaymentMethodDto
  ) {
    return (
      merchantPaymentMethod && merchantPaymentMethod?.paymentMethod?.isGiftCard
    );
  }

  private setIsPosSplitTableOrder(
    applicationSourceId: number,
    saleUnitCartSplit: SaleUnitCartSplitDto
  ) {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      !!saleUnitCartSplit
    );
  }

  private setIsPosSplitTableMainTableOrder(
    applicationSourceId: number,
    saleUnitCart: SaleUnitCartDto
  ): boolean {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      !!this.isPosTableOrder &&
      !this.isPosSplitTableOrder &&
      saleUnitCart.saleUnitCartSplits.length > 0
    );
  }

  private setIsSplitOrderPayment(
    orderPayments: MerchantPaymentMethodDto[]
  ): boolean {
    return orderPayments?.length > 0;
  }

  private setIsPosGiftCardPayment(
    applicationSourceId: number,
    orderPayments: MerchantPaymentMethodDto[]
  ): boolean {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      this.isSplitOrderPayment &&
      orderPayments.filter((x) => x.paymentMethod.isGiftCard).length > 0
    );
  }

  private setIsPosCardPayment(
    applicationSourceId: number,
    orderPayments: MerchantPaymentMethodDto[]
  ): boolean {
    return (
      applicationSourceId === this.applicationSourceEnum.WEB_POS &&
      this.isSplitOrderPayment &&
      orderPayments.filter((x) => x.paymentMethod.isCard && x.isCardIntegrated).length > 0
    );
  }
}
